import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/layout/Layout";
import AIChatWidget from "@/components/AIChatWidget";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ProcessosList from "@/pages/ProcessosList";
import ProcessoDetail from "@/pages/ProcessoDetail";
import TarefasList from "@/pages/TarefasList";
import ContatosList from "@/pages/ContatosList";
import UtilizadoresList from "@/pages/UtilizadoresList";
import TrabalhosList from "@/pages/TrabalhosList";
import PontoFerias from "@/pages/PontoFerias";
import ClientesPendentes from "@/pages/ClientesPendentes";
import Rendimento from "@/pages/Rendimento";
import MaioresDevedores from "@/pages/MaioresDevedores";
import PrazosCalendario from "@/pages/PrazosCalendario";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/processos" element={<ProcessosList />} />
                  <Route path="/processos/:id" element={<ProcessoDetail />} />
                  <Route path="/trabalhos" element={<TrabalhosList />} />
                  <Route path="/clientes-pendentes" element={<ClientesPendentes />} />
                  <Route path="/maiores-devedores" element={<MaioresDevedores />} />
                  <Route path="/rendimento" element={<Rendimento />} />
                  <Route path="/prazos-calendario" element={<PrazosCalendario />} />
                  <Route path="/ponto" element={<PontoFerias />} />
                  <Route path="/tarefas" element={<TarefasList />} />
                  <Route path="/contatos" element={<ContatosList />} />
                  <Route path="/utilizadores" element={<UtilizadoresList />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
              <AIChatWidget />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
